import { Box } from '@mui/joy';

/**
 * Сегментированный прогресс как в сторис: по сегменту на слайд,
 * активный заполняется за duration_seconds.
 */
export default function NewsProgressBar({
    total = 1,
    index = 0,
    percent = 0,
    dark = false,           // true для формата «Стандарт» (светлый фон)
}) {
    const track = dark ? 'rgba(0,0,0,0.14)' : 'rgba(255,255,255,0.30)';
    const fill  = dark ? 'rgba(0,0,0,0.72)' : '#ffffff';

    return (
        <Box sx={{
            display: 'flex',
            gap: '4px',
            px: 2,
            pt: 'calc(12px + env(safe-area-inset-top))',
            position: 'absolute',
            top: 0, left: 0, right: 0,
            boxSizing: 'border-box',
            zIndex: 7,
            pointerEvents: 'none',
        }}>
            {Array.from({ length: Math.max(1, total) }).map((_, i) => (
                <Box key={i} sx={{
                    flex: 1,
                    height: '3px',
                    borderRadius: '3px',
                    background: track,
                    overflow: 'hidden',
                }}>
                    <Box sx={{
                        height: '100%',
                        borderRadius: '3px',
                        background: fill,
                        width: i < index
                            ? '100%'
                            : i === index
                                ? `${Math.min(100, Math.max(0, percent))}%`
                                : '0%',
                        transition: i === index ? 'width 90ms linear' : 'none',
                    }} />
                </Box>
            ))}
        </Box>
    );
}